// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LrrsModel from '../../model/lrrs-model';
import LrrsDTO from '../dto/lrrs-dto';
import dtoSchema from '../schemas/lrrs-schema';
import LrrModel from '../../model/lrr-model';

export default abstract class LrrsModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LrrsDTO>) {
    super();
    if (data) {
      this.lrr = data.lrr?.map((i) => LrrModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  lrr?: LrrModel[];

  static toModel(dto: DeepPartial<LrrsDTO>): LrrsModel;
  static toModel(dto: DeepPartial<LrrsDTO> | undefined | null): LrrsModel | undefined;
  static toModel(dto: DeepPartial<LrrsDTO> | undefined | null): LrrsModel | undefined {
    return dto ? new LrrsModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LrrsModel> | LrrsModel): LrrsDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      lrr: unwrapped.lrr,
    } as LrrsDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LrrsModel, can not map to LrrsDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
